export default "__VITE_ASSET__62db0abb__"